import { PlainButton } from "@ui/components/buttons/PlainButton";
import { CheckmarkIcon } from "@ui/components/icons/CheckmarkIcon";
import styles from "@ui/components/buttons/css/CheckboxButton.module.css";
import { ColorValue } from "@ui/types/enums/ColorValue";

type Props = {
  isActive: boolean;
  onClick: (shiftKey: boolean) => void;
};

export function CheckboxButton({ isActive, onClick }: Props): JSX.Element {
  const className = isActive ? styles.active : styles.inactive;
  const children = isActive ? (
    <CheckmarkIcon colorValue={ColorValue.White} />
  ) : (
    // TODO: for some reason, if null is rendered here, there's weird layout shift
    // when selecting all rows in CardTable
    <CheckmarkIcon colorValue={ColorValue.WebsiteBackground} />
  );
  return (
    <PlainButton
      className={className}
      onClick={(e) => onClick(e.shiftKey)}
      transparentBg={false}
      type="button"
    >
      {children}
    </PlainButton>
  );
}
